<ng-container *ngIf="surveyViewerService.activeSurvey$ | async" data-testId="addressForm">
    <div data-testId="addressForm">
        <ng-container *ngIf="!questionFormControl.value.Id">
            <mat-form-field appearance="outline" class="mr-2" [ngClass]="{'address-mobile-container': isSmallScreen, 'address-desktop-container': !isSmallScreen, 'mat-form-field-invalid': questionFormControl.hasError(addressValidatorErrorName)}">
                <mat-label>{{question.statements[question.addressFormControlName].label | translateLabel: activeLang}}</mat-label>
                <input
                    appNoPaste
                    #trigger
                    (blur)="triggerValidation()"
                    (input)="getAddressSuggestions($event)"
                    [matAutocomplete]="auto"
                    [formControl]="addressFormControlPlaceholder"
                    matInput>
                <mat-option matSuffix *ngIf="canadaPostService.hasOngoingRequest$ | async">
                    <mat-spinner diameter="25"></mat-spinner>
                </mat-option>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="retrieveAddress($event)" [displayWith]="displayFn">
                    <mat-option *ngIf="!(addressSuggestions$ | async)">
                        {{'Aucune adresse trouvée'|transloco}}
                    </mat-option>
                    <mat-option *ngIf="(canadaPostService.precisionMode$ | async) && (addressSuggestions$ | async)" disabled class="too-many-options">
                        {{'Plusieurs portes trouvées à cette adresse. Veuillez préciser :'|transloco}}
                    </mat-option>
                    <ng-container *ngIf="addressSuggestions$ | async">
                        <mat-option *ngFor="let address of addressSuggestions$ | async" [value]="address">
                            {{ formatInputAddress(address) }}
                        </mat-option>
                    </ng-container>
                </mat-autocomplete>
                <mat-error>
                    {{'Adresse invalide. Veuillez en choisir une proposée dans la liste.'|transloco}}
                </mat-error>
            </mat-form-field>

            <app-countries (countryChanged)="resetPlaceholderForm()" [activeLang]="activeLang"></app-countries>
        </ng-container>

        <ng-container *ngIf="questionFormControl.value.Id">
            <div>
                <mat-form-field class="mr-4" appearance="outline">
                    <mat-label>
                        {{'Numéro civique'|transloco}}
                    </mat-label>
                    <input readonly matInput [formControl]="$any(questionFormControl.get('BuildingNumber'))">
                </mat-form-field>
                <mat-form-field class="mr-4" style="min-width: 250px" appearance="outline">
                    <mat-label>
                        {{'Rue'|transloco}}
                    </mat-label>
                    <input readonly matInput [formControl]="$any(questionFormControl.get('Street'))">
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>
                        {{'Appartement'|transloco}}
                    </mat-label>
                    <input readonly matInput [formControl]="$any(questionFormControl.get('SubBuilding'))">
                </mat-form-field>
            </div>

            <div>
                <mat-form-field class="mr-4" style="min-width: 250px" appearance="outline">
                    <mat-label>
                        {{'Ville'|transloco}}
                    </mat-label>
                    <input readonly matInput [formControl]="$any(questionFormControl.get('City'))">
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>
                        {{'Code postal'|transloco}}
                    </mat-label>
                    <input readonly matInput [formControl]="$any(questionFormControl.get('PostalCode'))">
                </mat-form-field>
            </div>

            <div>
                <mat-form-field class="mr-4" appearance="outline">
                    <mat-label>
                        {{'Province'|transloco}}
                    </mat-label>
                    <input readonly matInput [formControl]="$any(questionFormControl.get('Province'))">
                </mat-form-field>

                <mat-form-field style="min-width: 250px" appearance="outline">
                    <mat-label>
                        {{'Pays'|transloco}}
                    </mat-label>
                    <input readonly matInput [formControl]="$any(questionFormControl.get('CountryName'))">
                </mat-form-field>
            </div>

            <div class="mb-4" *ngIf="!questionFormControl.value.userConfirmed">
                {{"L'adresse est-elle correcte ?"|transloco}}

                <button class="mr-2 ml-2" mat-raised-button color="primary" style="color: white" (click)="confirmAddress()">{{'Oui'|transloco}}</button>
                <button mat-raised-button color="warn" (click)="resetForm()">{{'Non'|transloco}}</button>
            </div>

            <button mat-stroked-button *ngIf="questionFormControl.value.userConfirmed" color="primary" (click)="resetForm()">{{"Modifier l'adresse"|transloco}}</button>
        </ng-container>
    </div>

  <mat-error *ngIf="questionFormControl.errors && surveyViewerService.allFormControlsMarkedAsTouched$.value">
    {{"L'adresse est obligatoire et doit être confirmée."|transloco}}
  </mat-error>

</ng-container>
